import templateUrl from './service-area-providers-list.html';

export const serviceAreaProvidersListComponent = {
    bindings: {
        resolve: '<',
        close: '&'
    },

    templateUrl,

    controller: class ServiceAreaProvidersListComponent {
        constructor(ServiceAreaCountyService, ApiService) {
            'ngInject';
            
            this.serviceAreaCountyService = ServiceAreaCountyService;
            this.apiService = ApiService;
        }
        
        $onInit() {
            this.serviceAreaId = this.resolve.details.serviceAreaId;
            this.list = [];
            this._setProvidersList();
        }

        //******************************************Private Methods********************************* */

        /**
         * ‘Presently we are just considering Transportation providers which are linked with a given service area, but we can display all the contents which are linked with a given service area’
         */
        _setProvidersList() {
            this.serviceAreaCountyService.getContentLinkedWithServiceArea(this.serviceAreaId)
                .then(details => {
                    this.list = details;
                });
        }

        _getImage(image) {
			return image ? this.apiService.getResourceUrl(`files/images/${image}`) : '/./images/placeholder.png';
		}
    }
};


// WEBPACK FOOTER //
// ./src/app/components/service-area/service-area-providers-list/service-area-providers-list.component.js